<template>
  <section
    :id="faq.slug"
    class="faq-item"
    :class="{'faq-item--collapsed': isVisible}"
  >
    <div
      class="faq-item__header"
      @click="toggle"
    >
      <h3 class="faq-item__header__title">{{ faq.name }}</h3>
    </div>

    <div class="faq-item__body">
      <p class="faq-item__paragraph" v-html="faq.body"></p>
    </div>
  </section>
</template>

<script>
  export default {
    props: {
      faq: { type: Object, default: () => ({}) }
    },

    data: () => ({
      isVisible: false
    }),
    
    methods: {
      toggle () {
        this.isVisible = !this.isVisible
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "~@/assets/sass/variables";

  .faq-item {
    padding: 16px;
    transition: .5s all;
    border-radius: 8px;
    border: 1px solid #FFFFFF1A;
    background: $purple700;

    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      user-select: none;
      cursor: pointer;

      &:after {
        font-family: monospace;
        font-size: 20px;
        color: $white300;
        content: '>';
        transform: rotate(90deg);
        transition: .5s all;
      }

      &__title {
        font-size: 0.89rem;
      }
    }

    &__body {
      height: 0;
      overflow: hidden;
      transition: .5s all;

      & > * { display: none }
    }

    &--collapsed { 
      border-color: $highlightPrimaryColor;
    }

    &--collapsed &__body {
      height: 100%;
      padding-top: 20px;
      margin-top: 20px;
      border-top: 1px solid $white20;

      & > * { display: block }
    }

    &--collapsed &__header:after {
      transform: rotate(-90deg);
      color: $highlightPrimaryColor;
    }

    &__paragraph {
      font-size: 0.89rem;

      &:not(:last-child) {
        margin-bottom: 20px;
      }
    }
  }
</style>